var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWhiteboardHide = function SvgWhiteboardHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5v9h16V5H4Zm12.766 11H21a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h4.234l-2.091 3.486a1 1 0 1 0 1.715 1.029L9.566 16h4.868l2.709 4.515a1 1 0 0 0 1.715-1.03L16.766 16Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.147 3.479a1 1 0 0 1 1.375-.332l18 11a1 1 0 1 1-1.043 1.706l-18-11a1 1 0 0 1-.332-1.374Z",
    fill: "#fff"
  })));
};

export default SvgWhiteboardHide;